// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.header-container {
  align-items: center;
  background: white;
  color: #0669B3;
  display: flex;
  height: 80px;
  justify-content: space-between;
  margin-left: 12px;
  max-width: 100%;
  padding: 4px;
}
.header-container .header-dcsd-icon {
  align-items: center;
  display: flex;
  margin-left: 4px;
  margin-right: 36px;
}
.header-container .header-name-container {
  align-items: center;
  display: flex;
  font-size: 1rem;
  font-weight: bold;
  width: 80%;
}
.header-container .header-name-container h5 {
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
}
.header-container .header-position-container {
  margin-left: 4%;
  width: 80%;
}
.header-container .header-position-container h5 {
  font-size: 0.9rem;
  font-weight: 400;
  margin: 0;
}
.header-container .header-right {
  margin-left: auto;
}
.header-container .header-right .nav-button-container {
  align-items: center;
  display: flex;
  height: 72px;
}
.header-container .header-right .nav-button-container .nav-button-links {
  border-radius: 4px;
  padding: 0 15px 0 15px;
  text-transform: lowercase;
}
.header-container .header-right span {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.header-container .header-right span .nav-button-icon {
  padding-left: 10px;
}
.header-container .header-right .nav-button-text {
  color: white;
  font-size: 1em;
}
.header-container .header-right .nav-button-text .resources {
  color: white;
  text-decoration: none;
}

.a-action-button-dup {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  display: flex;
  height: 30px;
  text-decoration: none;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.a-action-button-dup:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.a-action-button-dup:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Header.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,mBAAA;EACA,iBAAA;EACA,cD0BS;ECzBT,aAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AAUJ;AARI;EACI,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AAUR;AAPI;EACI,mBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AASR;AALQ;EACI,eAAA;EACA,iBAAA;EACA,SAAA;AAOZ;AAHI;EACI,eAAA;EACA,UAAA;AAKR;AAJQ;EACI,iBAAA;EACA,gBAAA;EACA,SAAA;AAMZ;AAFI;EACI,iBAAA;AAIR;AAHQ;EACI,mBAAA;EACA,aAAA;EACA,YAAA;AAKZ;AAHY;EACI,kBAAA;EACA,sBAAA;EACA,yBAAA;AAKhB;AADQ;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGZ;AADY;EACI,kBAAA;AAGhB;AACQ;EACI,YAAA;EACA,cAAA;AACZ;AAAY;EACI,YAAA;EACA,qBAAA;AAEhB;;AAMA;EClFI,kBDmFsB;EC9DtB,2CAAA;EDgEA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,mBD3DS;EC4DT,YAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAHJ;AAKI;EACE,uBAAA;EACA,mBDrEa;ACkEnB;AAKI;EACE,YAAA;EACA,mBAAA;AAHN","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.header-container {\n    align-items: center;\n    background: white;\n    color: $pearl-blue;\n    display: flex;\n    height: 80px;\n    justify-content: space-between;\n    margin-left: 12px;\n    max-width: 100%;\n    padding: 4px;\n\n    & .header-dcsd-icon {\n        align-items: center;\n        display: flex;\n        margin-left: 4px;\n        margin-right: 36px;\n    }\n\n    .header-name-container {\n        align-items: center;\n        display: flex;\n        font-size: 1rem;\n        font-weight: bold;\n        width: 80%;\n    }\n\n    .header-name-container {\n        & h5 {\n            font-size: 1rem;\n            font-weight: bold;\n            margin: 0;\n        }\n    }\n\n    .header-position-container {\n        margin-left: 4%;\n        width: 80%;\n        h5 {\n            font-size: 0.9rem;\n            font-weight: 400;;\n            margin: 0;\n        }\n    }\n\n    .header-right {\n        margin-left: auto;\n        .nav-button-container {\n            align-items: center;\n            display: flex;\n            height: 72px;\n\n            & .nav-button-links {\n                border-radius: 4px;\n                padding: 0 15px 0 15px;\n                text-transform: lowercase;\n            }\n        }\n\n        span {\n            align-items: center;\n            display: flex;\n            flex-direction: row;\n            justify-content: center;\n\n            & .nav-button-icon {\n                padding-left: 10px;\n            }\n        }\n\n        .nav-button-text {\n            color: white;\n            font-size: 1em;\n            .resources {\n                color: white;\n                text-decoration: none;\n            }\n        }\n\n    }\n}\n\n\n.a-action-button-dup {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    align-items: center;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    display: flex;\n    height: 30px;\n    text-decoration: none;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
